/**
 * ReactionPopover displays a ReactionPanel within a Material UI Popover.
 */
import React from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'

import Popover from '@material-ui/core/Popover'

import ReactionPanel from './ReactionPanel'

const useStyles = makeStyles(
  theme => ({
    paper: {
      margin: theme.spacing(0.5, 0, 0)
    }
  }),
  {
    name: 'ReactionPopper'
  }
)

const ReactionPopover = props => {
  const { classes: classesProp, sentiments, initialReaction, onSubmit, ...rest } = props

  const classes = useStyles(props)
  return (
    <Popover classes={{ paper: classes.paper }} {...rest}>
      <ReactionPanel sentiments={sentiments} initialReaction={initialReaction} onSubmit={onSubmit} />
    </Popover>
  )
}

// ReactionPopover relays sentiments and onSubmit to ReactionPanel then
// relays the rest to Popover.

export default ReactionPopover
